export default __webpack_public_path__ + "static/media/2.fe116679.jpg";